// AdminLayout.js
import React from "react";
import {  Link } from "react-router-dom";
import { Box, Drawer, List, ListItem, ListItemText, Toolbar, AppBar, Typography,Button } from "@mui/material";

export default function AdminLayout({children}) {
  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: 240, boxSizing: "border-box" },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          <List>
            {/* Add navigation links here */}
            <ListItem button component={Link} to="/admin/dashboard">
              <ListItemText primary="Dashboard" />
            </ListItem>
            <ListItem button component={Link} to="/admin/research">
              <ListItemText primary="Research" />
            </ListItem>
            <ListItem button component={Link} to="/admin/settings">
              <ListItemText primary="Settings" />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      {/* Main content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
       <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          {/* Left side - Title */}
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Admin Panel
          </Typography>

          {/* Right side - Logout Button */}
          <Button 
            color="inherit" 
            onClick={() => {
              localStorage.clear(); // clear token/role
              window.location.href = "/"; // redirect to login/home
            }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

        <Toolbar />
        {/* Routed child pages will appear here */}
        {children}
      </Box>
    </Box>
  );
}
